import { render, staticRenderFns } from "./EditComplementaryTreatmentsDialog.vue?vue&type=template&id=69dc641d&scoped=true"
import script from "./EditComplementaryTreatmentsDialog.vue?vue&type=script&lang=js"
export * from "./EditComplementaryTreatmentsDialog.vue?vue&type=script&lang=js"
import style0 from "./EditComplementaryTreatmentsDialog.vue?vue&type=style&index=0&id=69dc641d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dc641d",
  null
  
)

export default component.exports